import { BaseResponse } from '@/types/common';
import axiosInstance from './axiosInstance';
import {
  UserDetail,
  UserMngBatchBanParams,
  UserMngHistoryParams,
  UserMngHistoryResponse,
  UserMngListParams,
  UserMngListResponse,
} from '@/types/userMng';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 获取用户管理列表
 * @param params - 查询参数
 * @returns Promise<BaseResponse<UserMngListResponse>> 用户列表响应
 */
export const getUserMngList = async (params: UserMngListParams) => {
  const resp = await axiosInstance.post<BaseResponse<UserMngListResponse>>(
    `${baseUrl}/review/user/v1/list`,
    params
  );
  return resp.data;
};

/**
 * 批量解禁用户
 * @param params - 批量解禁参数
 * @returns Promise<BaseResponse<void>> 解禁结果
 */
export const batchUnforbiddenUser = async (params: UserMngBatchBanParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/user/batch/unforbidden`,
    params
  );
  return resp.data;
};

/**
 * 解禁用户
 * @param params - 解禁参数
 * @returns Promise<BaseResponse<void>> 解禁结果
 */
export const unforbiddenUser = async (params: UserMngBatchBanParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/user/unforbidden`,
    params
  );
  return resp.data;
};

/**
 * 批量禁用用户
 * @param params - 批量禁用参数
 * @returns Promise<BaseResponse<void>> 禁用结果
 */
export const batchForbiddenUser = async (params: UserMngBatchBanParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/user/batch/forbidden`,
    params
  );
  return resp.data;
};

/**
 * 禁用用户
 * @param params - 禁用参数
 * @returns Promise<BaseResponse<void>> 禁用结果
 */
export const forbiddenUser = async (params: UserMngBatchBanParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/user/forbidden`,
    params
  );
  return resp.data;
};

/**
 * 获取用户详情
 * @param userId - 用户ID
 * @returns Promise<BaseResponse<UserDetail>> 用户详情响应
 */
export const getUserDetail = async (userId: string) => {
  const resp = await axiosInstance.get<BaseResponse<UserDetail>>(
    `${baseUrl}/review/user/detail/${userId}`
  );
  return resp.data;
};

/**
 * 获取用户管理历史
 * @param params - 查询参数
 * @returns Promise<BaseResponse<UserMngHistoryResponse>> 用户管理历史响应
 */
export const getUserMngHistory = async (params: UserMngHistoryParams) => {
  const resp = await axiosInstance.post<BaseResponse<UserMngHistoryResponse>>(
    `${baseUrl}/review/user/operation/list`,
    params
  );
  return resp.data;
};

export interface BatchUserWarnParams {
  userIds: string;
  warnDesc: string;
  warnTime: number;
  timeUnit?: 'M' | 'H' | 'D';
}

/**
 * 批量警告用户
 * @param params - 批量警告参数
 * @returns Promise<BaseResponse<void>> 警告结果
 */
export const batchUserWarn = async (params: BatchUserWarnParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/user/warn`,
    params
  );
  return resp.data;
};

export interface BatchUserFrozenParams {
  userIds: string;
  warnDesc: string;
  forzenTime: number;
  forzenTimeUnit?: 'D';
  warnTime: number;
  timeUnit?: 'D';
}

export const batchUserFrozen = async (params: BatchUserFrozenParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/user/frozen`,
    params
  );
  return resp.data;
};

export const batchUserUnFrozen = async (params: { userIds: string; warnDesc: string }) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/user/unFrozen`,
    params
  );
  return resp.data;
};

export interface BatchUserDeAlertParams {
  userIds: string;
  warnDesc: string;
}

/**
 * 批量解除警告
 * @param params - 批量解除警告参数
 * @returns Promise<BaseResponse<void>> 解除警告结果
 */
export const batchUserDeAlert = async (params: BatchUserDeAlertParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/user/unWarn`,
    params
  );
  return resp.data;
};
